import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Spinner from '../../Components/Spinner/Spinner';
import axios from '../../config/axiosConfig';
import './DeepLink.scss';

const DEEP_LINK_ID_QUERY = 'id';
const DEEP_LINK_ERROR_QUERY = 'deepLinkError';
const DEFAULT_DEEP_LINK_ERROR = 'Unable to process deep link.';

function DeepLink(): JSX.Element {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const id = searchParams.get(DEEP_LINK_ID_QUERY);

    if (!id) {
      navigate(
        `/?${DEEP_LINK_ERROR_QUERY}=${encodeURIComponent(DEFAULT_DEEP_LINK_ERROR)}`,
        { replace: true }
      );
      return;
    }

    axios
      .get<string>('api/DeepLink', { params: { id } })
      .then((response) => {
        const redirectUrl = response.data;

        try {
          new URL(redirectUrl);
          window.location.replace(redirectUrl);
        } catch {
          navigate(
            `/?${DEEP_LINK_ERROR_QUERY}=${encodeURIComponent(DEFAULT_DEEP_LINK_ERROR)}`,
            { replace: true }
          );
        }
      })
      .catch((error: unknown) => {
        const message =
          typeof error === 'string' && error.trim().length > 0
            ? error
            : DEFAULT_DEEP_LINK_ERROR;

        navigate(`/?${DEEP_LINK_ERROR_QUERY}=${encodeURIComponent(message)}`, {
          replace: true,
        });
      });
  }, [navigate, searchParams]);

  return (
    <div className="nqt-deep-link-container">
      <Spinner size={90} />
    </div>
  );
}

export default DeepLink;
